import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconBed24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="bed">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 4.5a1 1 0 0 1 2 0V13h18v6a1 1 0 1 1-2 0v-2H4v2a1 1 0 1 1-2 0zM5.5 9.5a2.5 2.5 0 1 1 5 0a2.5 2.5 0 1 1-5 0zM12 8h7a3 3 0 0 1 3 3v1H12z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconBed16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="bed">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 4.5a1 1 0 0 1 2 0V13h18v6a1 1 0 1 1-2 0v-2H4v2a1 1 0 1 1-2 0zM5.5 9.5a2.5 2.5 0 1 1 5 0a2.5 2.5 0 1 1-5 0zM12 8h7a3 3 0 0 1 3 3v1H12z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
